/**
 * Converts a given date to a specific time zone.
 *
 * @param date - The date to convert.
 * @param tzString - The time zone string (e.g. 'America/New_York').
 *
 * @returns A new Date object representing the converted date in the specified time zone.
 */
export const convertTimeZone = (date: Date, tzString: string) => {
  return new Date(
    (typeof date === 'string' ? new Date(date) : date).toLocaleString('en-US', {
      timeZone: tzString,
    }),
  );
};
